// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"26654":"a5937532ba4fca98","93255":"19e3be7a5ee2d86b"}[chunkId] + ".css";
};